import { provide, inject } from 'vue';


const checkoutContextKey = Symbol('checkout-context');

export function provideCheckoutContext(context) {
  provide(checkoutContextKey, context);
}

export function useCheckoutContext() {
  return inject(checkoutContextKey, undefined);
}

// export type CheckoutContext = {
//   product?: any;
//   checkout?: any;
//   builder?: any;
//   template?: string;  
//   offer?: any;
//   pixels?: any[];
//   visit?: any;
// form: any
// };

// const checkoutContextKey: InjectionKey<CheckoutContext> = Symbol('checkout-context');

// export function provideCheckoutContext(context: CheckoutContext): void {
//   provide(checkoutContextKey, context);
// }

// export function useCheckoutContext(): CheckoutContext | undefined {
//   return inject(checkoutContextKey, undefined);
// }